// extracted by mini-css-extract-plugin
export var cookie = "Cookies-module--cookie--cb277";
export var cookieIcon = "Cookies-module--cookieIcon--5234f";
export var cookieOptions = "Cookies-module--cookieOptions--17ac9";
export var modal = "Cookies-module--modal--f42e1";